<template>
  <div class="navbar-fixed-wrapper">
    <nav class="navbar navbar-expand-lg navbar-dark main-navbar">
      <div class="container-fluid navBar">
        <a href="/">
          <img
            class="LOGOICON"
            src="../assets/img-1/UnionOceanLOGO-02-w.png"
            alt="Union Ocean Logo"
          />
        </a>

        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavAltMarkup"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
          <div class="navbar-nav align-items-lg-center">
            <div class="nav-link dropdown">
              <a
                class="dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
              >
                {{ $t("about") }}
              </a>

              <ul class="dropdown-menu">
                <li>
                  <router-link class="nav-link" to="/AboutPage">
                    {{ $t("aboutUs") }}
                  </router-link>
                </li>

                <li>
                  <a
                    class="nav-link"
                    href="#"
                    @click.prevent="goToSection('Order-Process')"
                  >
                    {{ $t("orderProcess") }}
                  </a>

                  <a
                    class="nav-link"
                    href="#"
                    @click.prevent="goToSection('faq')"
                  >
                    {{ $t("faq") }}
                  </a>
                </li>
              </ul>
            </div>

            <router-link class="nav-link" to="/Blog"> 教育專欄 </router-link>

            <a
              class="nav-link scrollto"
              href="#"
              @click.prevent="goToSection('video')"
            >
              {{ $t("video") }}
            </a>

            <a
              class="nav-link scrollto"
              href="#"
              @click.prevent="goToSection('download')"
            >
              {{ $t("download") }}
            </a>

            <a
              class="nav-link scrollto"
              href="#"
              @click.prevent="goToSection('contact')"
            >
              {{ $t("contactUS") }}
            </a>

            <div class="search-box">
              <input
                v-model="keyword"
                type="text"
                class="search-input"
                placeholder="搜尋教材、系列、出版社..."
              />

              <button
                v-if="keyword"
                type="button"
                class="clear-btn"
                @click="keyword = ''"
              >
                ×
              </button>

              <button class="search-btn" type="button">
                <i class="bi bi-search"></i>
              </button>

              <div
                v-if="keyword && filteredResults.length"
                class="search-dropdown"
              >
                <router-link
                  v-for="item in filteredResults"
                  :key="item.path"
                  :to="item.path"
                  class="search-result-item"
                  @click="keyword = ''"
                >
                  <strong class="search-title">
                    {{ item.title }}
                  </strong>

                  <span class="search-meta">
                    {{ item.category }}

                    <template v-if="item.publisher">
                      ・{{ item.publisher }}
                    </template>
                  </span>
                </router-link>
              </div>

              <div
                v-else-if="keyword && !filteredResults.length"
                class="search-dropdown no-result"
              >
                找不到相關教材
              </div>
            </div>

            <div class="lang-switch ms-lg-3">
              <button
                type="button"
                class="lang-btn"
                :class="{ active: currentLang === 'zh' }"
                @click="switchLang('zh')"
              >
                <!-- 中 -->
              </button>

              <button
                type="button"
                class="lang-btn"
                :class="{ active: currentLang === 'en' }"
                @click="switchLang('en')"
              >
                <!-- EN -->
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "NavBar",

  data() {
    return {
      currentLang: localStorage.getItem("lang") || "zh",
      keyword: "",
      searchData: [],
    };
  },

  computed: {
    filteredResults() {
      const query = this.keyword.trim().toLowerCase();

      if (!query) return [];

      return this.searchData.filter((item) => {
        const text = `
          ${item.title || ""}
          ${item.category || ""}
          ${item.publisher || ""}
          ${item.keywords || ""}
        `.toLowerCase();

        return text.includes(query);
      });
    },
  },

  methods: {
    switchLang(lang) {
      this.currentLang = lang;
      this.$i18n.locale = lang;
      localStorage.setItem("lang", lang);
    },

    goToSection(sectionId) {
      const target = document.getElementById(sectionId);

      // 目前就在首頁時，直接捲動到指定區塊
      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        return;
      }

      // 在其他頁面時，先記住目標，再回到首頁
      sessionStorage.setItem("scrollTarget", sectionId);
      window.location.href = "/";
    },

    async getSearchData() {
      const url =
        "https://docs.google.com/spreadsheets/d/1ZoosVN34HKZNuTNAMJ2QeiXmr242mKYNPkLLuPExyzc/gviz/tq?tqx=out:json&gid=1387593991";

      try {
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`HTTP 錯誤：${response.status}`);
        }

        const text = await response.text();

        const jsonText = text.substring(47).slice(0, -2);
        const json = JSON.parse(jsonText);

        const rows = json.table.rows || [];

        this.searchData = rows
          .map((row) => {
            return {
              title: row.c[0]?.v || "",
              category: row.c[1]?.v || "",
              description: row.c[2]?.v || "",
              keywords: row.c[3]?.v || "",
              path: row.c[4]?.v || "",
              publisher: row.c[5]?.v || "",
            };
          })
          .filter((item) => item.title && item.path);
      } catch (error) {
        console.error("搜尋資料讀取失敗：", error);
        this.searchData = [];
      }
    },
  },

  mounted() {
    this.$i18n.locale = this.currentLang;
    this.getSearchData();

    const sectionId = sessionStorage.getItem("scrollTarget");

    if (sectionId) {
      let attempts = 0;
      const maxAttempts = 20;

      const scrollWhenReady = () => {
        const target = document.getElementById(sectionId);

        if (target) {
          sessionStorage.removeItem("scrollTarget");
          target.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
          return;
        }

        attempts += 1;

        if (attempts < maxAttempts) {
          window.setTimeout(scrollWhenReady, 150);
        } else {
          sessionStorage.removeItem("scrollTarget");
          console.warn(`找不到 id="${sectionId}" 的區塊`);
        }
      };

      this.$nextTick(scrollWhenReady);
    }
  },
};
</script>

<style>
.navbar-fixed-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 99999;
  pointer-events: auto;
  isolation: isolate;
}

.main-navbar {
  width: 100%;
  background-color: #00489b;
  pointer-events: auto;
}

.main-navbar a,
.main-navbar button,
.main-navbar input {
  pointer-events: auto;
}

#Order-Process,
#faq,
#video,
#download,
#contact {
  scroll-margin-top: 90px;
}

@media (min-width: 1077px) {
  .navbar > .container-fluid {
    margin: 0 15%;
  }
}

.navbar-collapse {
  display: flex;
  flex-basis: auto;
  flex-direction: row-reverse;
}

.lang-switch {
  display: flex;
  align-items: center;
  margin-left: 12px;
  color: #ffffff;
}

.lang-btn {
  background: transparent;
  border: none;
  color: #ffffff;
  font-size: 14px;
  padding: 0 4px;
  cursor: pointer;
}

.lang-btn.active {
  font-weight: bold;
  text-decoration: underline;
}

.divider {
  color: #ffffff;
  margin: 0 4px;
}

.dropdown-toggle {
  color: #ffffff;
  text-decoration: none;
  cursor: pointer;
}

.dropdown-toggle:hover {
  color: #ffffff;
}

/* 搜尋 Bar */
.search-box {
  position: relative;
  margin-left: 18px;
  width: 260px;
}

.search-input {
  width: 100%;
  height: 40px;
  padding: 0 86px 0 18px;
  border-radius: 999px;
  border: 1.5px solid rgba(255, 255, 255, 0.85);
  background: transparent;
  color: #ffffff;
  font-size: 14px;
  outline: none;
  transition: all 0.25s ease;
  box-sizing: border-box;
}
.search-input::placeholder {
  color: rgba(255, 255, 255, 0.65);
}

.search-input:focus {
  border-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.12);
}

.search-btn {
  position: absolute;
  top: 0;
  right: 16px;
  width: 42px;
  height: 40px;
  border: none;
  border-left: 1px solid rgba(255, 255, 255, 0.45);
  background: transparent;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-btn i {
  font-size: 16px;
  color: #ffffff;
}

.clear-btn {
  position: absolute;
  top: 50%;
  right: 70px;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  color: #ffffff;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  z-index: 20;
}

/* 搜尋結果 dropdown：獨立樣式 */
.search-dropdown {
  position: absolute;
  top: 52px;
  right: 0;
  width: max-content;
  min-width: 420px;
  max-width: 720px;
  max-height: 350px;
  background: #ffffff;
  border-radius: 20px;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.18);
  z-index: 10000;
  padding: 6px 0;
}

/* 搜尋結果 item：清掉 navbar / a 樣式干擾 */
.search-dropdown .search-result-item {
  all: unset;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  cursor: pointer;
  padding: 12px 26px;
  position: relative;
  white-space: nowrap;
}

.search-dropdown .search-result-item:hover {
  background: #f4f8ff;
}

/* 分隔線到底 */
.search-dropdown .search-result-item::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 1px;
  background: #e5e5e5;
}

.search-dropdown .search-result-item:last-child::after {
  display: none;
}

.search-dropdown .search-title {
  font-size: 15px;
  font-weight: 700;
  color: #00489b;
  flex-shrink: 0;
}

.search-dropdown .search-meta {
  font-size: 12px;
  color: #888888;
  flex-shrink: 0;
}

.search-meta {
  padding-right: 18px;
}

/* 沒有結果 */
.search-dropdown.no-result {
  padding: 16px 20px;
  color: #777777;
  font-size: 14px;
}

/* scrollbar 美化 */
.search-dropdown::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.search-dropdown::-webkit-scrollbar-track {
  background: transparent;
}

.search-dropdown::-webkit-scrollbar-thumb {
  background: #b8b8b8;
  border-radius: 999px;
}

.search-dropdown::-webkit-scrollbar-corner {
  background: transparent;
}

/* 手機版 */
@media (max-width: 991px) {
  html,
  body {
    overflow-x: hidden;
    width: 100%;
  }

  .navbar,
  .navbar-collapse,
  .navbar-nav {
    width: 100%;
    overflow-x: hidden;
  }

  .search-box {
    position: relative;
    width: 100%;
    margin: 10px 0;
    padding: 0 16px;
    box-sizing: border-box;
  }

  .search-input {
    position: relative;
    z-index: 20;
  }

  .search-btn {
    right: 16px;
    color: #ffffff;
    z-index: 20;
  }

  .search-btn i {
    color: #ffffff;
  }

  .clear-btn {
    right: 70px;
    color: #ffffff;
    z-index: 20;
  }

  .search-dropdown {
    position: static;
    width: 100%;
    min-width: unset;
    max-width: 100%;
    margin-top: 8px;

    overflow-x: hidden;
    box-sizing: border-box;

    z-index: 10;
  }

  .search-dropdown .search-result-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    width: 100%;
    padding: 16px 20px;

    white-space: normal;
    word-break: break-word;

    box-sizing: border-box;
  }

  .search-dropdown .search-title {
    display: block;
    width: 100%;

    margin-bottom: 6px;

    line-height: 1.5;
    text-align: left;

    white-space: normal;
    word-break: break-word;
  }

  .search-dropdown .search-meta {
    display: block;
    width: 100%;

    line-height: 1.4;
    text-align: left;

    white-space: normal;
    word-break: break-word;
  }

  .search-meta {
    padding-right: 0;
  }
}

.search-input,
.search-btn,
.clear-btn {
  z-index: 20;
}

.search-dropdown {
  z-index: 10;
}
</style>
